module.exports = __webpack_public_path__ + "img/5.89c15b6c.jpg";